import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import LookupPatient from './LookupPatient';

const PatientManagementRoutes = () => (
  <Routes>
    <Route path='lookup' element={<LookupPatient />} />
    {/* <Route path='lookup-rpm' element={<LookupPatient />} /> */}
    <Route path='lookup-ccm' element={<Navigate to='/patients/lookup' replace />} />
    {/* fallback for default ... */}
    <Route path='' element={<LookupPatient />} />
  </Routes>
);

export default PatientManagementRoutes;
